export const da = {
  helpPageTitle: "PostNord Shipping FAQ",
  qa: [
    {
      q: "Hvordan virker PostNord Shipping?",
      a: "PostNord Shipping gør det nemt at udskrive labels og lader dine kunder vælge levering til <a href='https://www.postnord.dk/sende/pakker-erhverv/mypack-collect' target='_blank'>udleveringssted</a> eller <a href='https://www.postnord.dk/sende/pakker-erhverv/mypack-home' target='_blank'>hjemmeadresse</a> under checkout."
    },
    {
      q: "Hvordan kommer jeg i gang?",
      a: "Gennemfør vores setup guide og giv os et par dage til at få opsætningen på plads med PostNord. Vi beklager denne ventetid og forventer det kan ændre sig i fremtiden."
    },
    {
      q: "I hvilke lande virker PostNord Shipping?",
      a: "Danmark, Sverige og Norge."
    },
    {
      q: "Hvilke ordrer kan jeg udskrive labels for?",
      a: "Alle ordrer der er betalt og ikke afsendt. Ordrer der allerede har et tracking nummer kan tilvælges under \"Vælg ordrer\" => \"Inkluder ordrer med tracking nummer\"."
    },
    {
      q: "Hvad sker der når jeg udskriver labels?",
      a: "En PDF oprettes med labels for alle valgte ordrer, og et tracking nummer registreres for de valgte ordrer. Ordrer skifter ikke status til afsendt, da vi forventer du selv ønsker at gøre dette når pakken er afsendt."
    },
    {
      q: "Kan jeg justere vægt for en ordre?",
      a: "Ja, du kan justere vægten for en ordre før udskrift af label, eksempelvis hvis du har tilføjet lidt ekstra til pakken. Klik \"Vælg ordrer\" og juster vægt angivet i højre side."
    },
    {
      q: "Hvordan betaler jeg for forsendelse?",
      a: "Helt på normal vis, direkte til PostNord. Du vil modtage månedlige faktura."
    },
    {
      q: "Er der nogle indstillinger i Ecwid jeg bør være opmærksom på?",
      a: "Vær sikker på du har aktiveret feature <strong>Show address fields relevant to customer’s country only</strong> (se Indstillinger => Hvad er nyt) for at sikre at adressefelter behandles korrekt under checkout. Shops oprettet efter februar 2021 vil have denne feature aktiveret fra starten."
    },
    {
      q: "Hvem er bag PostNord Shipping?",
      a: "Vi er en lille software virksomhed der har arbejdet sammen med PostNord og Ecwid om at forsimple oprettelsen af pakke labels og valg af udleveringssted. <a href='http://www.norpoint.net' target='_blank'>Find os her</a>."
    },
    {
      q: "Gemmer I GDPR-relateret informationer?",
      a: "De eneste personlige informationer vi gemmer er din email adresse, så vi kan kontakte dig når din konto er opsat."
    },
    {
      q: "Jeg har et problem eller forslag - hvordan kontakter jeg jer?",
      a: "Skriv endelig! Du kan kontakte os på <a href=\"mailto:postnord-shipping@norpoint.net\">postnord-shipping@norpoint.net</a>"
    },
  ]
};

export const en = {
  helpPageTitle: "PostNord Shipping FAQ",
  qa: [
    {
      q: "What does PostNord Shipping do?",
      a: "PostNord Shipping makes it easy to print labels and lets your customers select shipping to <a href='https://www.postnord.dk/en/sending/parcels-business/mypack-collect' target='_blank'>collection point</a> or <a href='https://www.postnord.dk/en/sending/parcels-business/mypack-home' target='_blank'>home address during checkout.</a>"
    },
    {
      q: "How do I get started?",
      a: "Complete our setup guide and give us a few days to complete the account setup with PostNord. We apologize for the delay due to this manual effort and expect it to improve over time."
    },
    {
      q: "Which countries are supported?",
      a: "Denmark, Sweden and Norway."
    },
    {
      q: "Which orders can I print labels for?",
      a: "All orders that are paid and not yet shipped. Orders that already have a tracking number can be added by choosing \"Select orders\" => \"Include orders with tracking number\"."
    },
    {
      q: "What happens when I print labels?",
      a: "A PDF is created with labels for the selected orders, and a tracking number is registered for each order. Orders do not change status to Shipped, since we expect you will want to do this yourself once the package ships."
    },
    {
      q: "Can I adjust weight for an order?",
      a: "Yes, you can adjust the weight of an order before printing the label, e.g. if you've added something extra to the order. Click \"Select orders\" and adjust weight on right hand side of each order."
    },
    {
      q: "How do I pay for shipping?",
      a: "As you would normally: Directly to PostNord. You should receive a monthly invoice."
    },
    {
      q: "Are there any store settings that I should be mindful of?",
      a: "Make sure you've enabled a newly added feature called <strong>Show address fields relevant to customer’s country only</strong> (see Settings => Whats new) to make sure shipping address fields are correctly validated during checkout. Shops created after february 2021 should have this feature enabled by default."
    },
    {
      q: "Who is behind PostNord Shipping?",
      a: "We are a small, Danish software company who have collaborated with PostNord and Ecwid til simplify the creation of parcel labels. <a href='http://www.norpoint.net' target='_blank'>Find us here</a>.",
    },
    {
      q: "Do you store GDPR-relateret information?",
      a: "The only personal information we store is your email address, in order to contact you after completion of account setup."
    },
    {
      q: "I have a problem or suggestion - how do I contact you?",
      a: "Do get in touch! You can reach us at <a href=\"mailto:postnord-shipping@norpoint.net\">postnord-shipping@norpoint.net</a>"
    },
  ]
};
